import * as Yup from "yup";

export function initialValues(document) {
  return {
    path: document?.path || "",
    documentId: document?.documentId || "",
    comment: document?.comment || "",
  };
}

export function validationSchema(document) {
  console.log("document", document);

  if (document) {
    return Yup.object({
      documentId: Yup.string().required("El documento es obligatorio"),
      comment: Yup.string(),
      documentPath: Yup.mixed().test(
        "fileType",
        "El archivo debe ser una imagen o un PDF",
        (value) => {
          if (!value) return true;
          const allowedExtensions = ["jpg", "jpeg", "png", "gif", "pdf"];
          const extension = value.path.split(".").pop().toLowerCase();
          return allowedExtensions.includes(extension);
        }
      ),
    });
  } else {
    return Yup.object({
      documentId: Yup.string().required("El documento es obligatorio"),
      comment: Yup.string(),
      documentPath: Yup.mixed()
        .required("Es obligatorio subir un archivo")
        .test(
          "fileType",
          "El archivo debe ser una imagen o un PDF",
          (value) => {
            if (!value) return false;
            const allowedExtensions = ["jpg", "jpeg", "png", "gif", "pdf"];
            const extension = value.path.split(".").pop().toLowerCase();
            return allowedExtensions.includes(extension);
          }
        ),
    });
  }
}
